// Help-desk access (admin only): tick a customer on the Customer list to give it.
export const getStaffURL = { url: "/admin/staff", method: "GET" };
export const grantHelpDeskURL = (customerId: string) => ({ url: `/admin/staff/customers/${customerId}`, method: "PUT" });
export const revokeHelpDeskURL = (customerId: string) => ({ url: `/admin/staff/customers/${customerId}`, method: "DELETE" });
